// extracted by mini-css-extract-plugin
export var addButton = "_oi-0";
export var border = "_oi-8";
export var check = "_oi-h";
export var danger = "_oi-6";
export var dropdownContainer = "_oi-1";
export var editModalBody = "_oi-j";
export var footerContainer = "_oi-i";
export var fullWidth = "_oi-a";
export var hide = "_oi-9";
export var icon = "_oi-3";
export var input = "_oi-7";
export var inputFlex = "_oi-b";
export var inputWrapper = "_oi-c";
export var manualFocus = "_oi-5";
export var optionButton = "_oi-4";
export var pillWrapper = "_oi-e";
export var pointer = "_oi-2";
export var showOverflow = "_oi-f";
export var tagsFlex = "_oi-d";
export var xButton = "_oi-g";